export const categories = [
  {
    name: "cat_shoes",
    label: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
  },
  {
    name: "cat_hoodies",
    label: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Hoodies.html",
  },
  {
    name: "cat_tshirts",
    label: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/T-Shirts.html",
  },
  {
    name: "cat_jackets",
    label: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Jackets.html",
  },
  {
    name: "cat_pants",
    label: "Pants/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Pants.html",
  },
  {
    name: "cat_headwear",
    label: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Headwear.html",
  },
  {
    name: "cat_sets",
    label: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Sets.html",
  },
  {
    name: "cat_underwear",
    label: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Underwear.html",
  },
  {
    name: "cat_jersey",
    label: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Jersey.html",
  },
  {
    name: "cat_accessories",
    label: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Accessories.html",
  },
  {
    name: "cat_bags",
    label: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Bags.html",
  },
  {
    name: "cat_belts",
    label: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Belts.html",
  },
  {
    name: "cat_perfumes",
    label: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Perfumes.html",
  },
  {
    name: "cat_other",
    label: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Other.html",
  },
];

export const latestArticles = [
  {
    id: "1",
    category: "Spreadsheet",
    title: "How to Use the AllChinaBuy Spreadsheet for Faster Product Discovery",
    description: "Learn how to navigate the AllChinaBuy spreadsheet, filter by category, and find trusted sellers with verified reviews.",
    updated: "2026-08-20",
    slug: "how-to-use-allchinabuy-spreadsheet",
  },
  {
    id: "2",
    category: "QC",
    title: "AllChinaBuy QC Guide: How to Request and Read Quality Check Photos",
    description: "A complete guide to requesting QC photos, understanding what to look for, and making informed buying decisions.",
    updated: "2026-08-18",
    slug: "allchinabuy-qc-guide",
  },
  {
    id: "3",
    category: "Shipping",
    title: "AllChinaBuy Shipping Methods Comparison: Which Option Is Best for You?",
    description: "Compare EMS, DHL, FedEx, and other shipping options with timelines, costs, and best-use scenarios for each country.",
    updated: "2026-08-15",
    slug: "allchinabuy-shipping-comparison",
  },
  {
    id: "4",
    category: "Sellers",
    title: "Finding Trusted Sellers on AllChinaBuy: What to Look For",
    description: "Discover the key indicators of reliable sellers, how to read reviews, and tips for avoiding risky transactions.",
    updated: "2026-08-12",
    slug: "finding-trusted-sellers-allchinabuy",
  },
  {
    id: "5",
    category: "Safety",
    title: "Is AllChinaBuy Safe? A Complete Safety Guide for New Buyers",
    description: "Understand the safety measures, payment protections, and common risks when buying through AllChinaBuy platform.",
    updated: "2026-08-10",
    slug: "is-allchinabuy-safe",
  },
  {
    id: "6",
    category: "Review",
    title: "AllChinaBuy Review 2026: Features, Shipping, and User Experience",
    description: "An in-depth review covering AllChinaBuy features, warehouse process, shipping experience, and what buyers should know.",
    updated: "2026-08-08",
    slug: "allchinabuy-review-2026",
  },
];

export const pillarArticles = [
  {
    id: "p1",
    category: "Spreadsheet",
    title: "AllChinaBuy Spreadsheet 2026: Complete Guide & Best Resources",
    description: "The definitive overview of the AllChinaBuy spreadsheet — how it works, what it includes, and how to use it to find products and sellers faster.",
    updated: "2026-08-22",
    slug: "allchinabuy-spreadsheet-2026",
  },
  {
    id: "p2",
    category: "Sellers",
    title: "AllChinaBuy Seller Spreadsheet: How to Find Verified Sellers",
    description: "Learn how to read the seller spreadsheet, spot reliable vendors, and build your own trusted-seller shortlist for safer shopping.",
    updated: "2026-08-21",
    slug: "allchinabuy-seller-spreadsheet",
  },
  {
    id: "p3",
    category: "Spreadsheet",
    title: "AllChinaBuy Product Spreadsheet: Categories & Navigation",
    description: "A walkthrough of the product spreadsheet structure, category filters, and tips for navigating hundreds of listings efficiently.",
    updated: "2026-08-19",
    slug: "allchinabuy-product-spreadsheet",
  },
  {
    id: "p4",
    category: "Shipping",
    title: "AllChinaBuy Shipping Cost: Complete Guide & Comparison",
    description: "Understand shipping costs, methods, timelines, and how to compare options so you never overpay for delivery.",
    updated: "2026-08-17",
    slug: "allchinabuy-shipping-cost-guide",
  },
  {
    id: "p5",
    category: "Warehouse",
    title: "AllChinaBuy Warehouse Guide: How Storage & QC Work",
    description: "A clear explanation of the warehouse process — storage, inspection, QC photos, packaging, and dispatch from start to finish.",
    updated: "2026-08-16",
    slug: "allchinabuy-warehouse-process",
  },
  {
    id: "p6",
    category: "Deals",
    title: "AllChinaBuy Coupon & Discount Code: Updated Guide",
    description: "Where to find current AllChinaBuy coupons and discount codes, how to apply them, and what to know before checkout.",
    updated: "2026-08-14",
    slug: "allchinabuy-coupon-discount-code",
  },
  {
    id: "p7",
    category: "Safety",
    title: "Is AllChinaBuy Legit? Safety, Review & Buying Guide",
    description: "A balanced look at whether AllChinaBuy is legit, covering safety measures, common risks, and how to shop with confidence.",
    updated: "2026-08-13",
    slug: "is-allchinabuy-legit",
  },
  {
    id: "p8",
    category: "Guide",
    title: "AllChinaBuy Beginner Guide: Start Buying Step by Step",
    description: "A step-by-step beginner walkthrough for your first AllChinaBuy order, from finding a product to tracking your package.",
    updated: "2026-08-11",
    slug: "allchinabuy-beginner-guide",
  },
  {
    id: "p9",
    category: "QC",
    title: "AllChinaBuy QC Photos Guide: How to Read Quality Checks",
    description: "How to request QC photos, what details to inspect, and how to use them to make smarter buying decisions.",
    updated: "2026-08-09",
    slug: "allchinabuy-qc-photos-guide",
  },
  {
    id: "p10",
    category: "Review",
    title: "AllChinaBuy Alternatives: Comparison & Buying Guide",
    description: "Compare AllChinaBuy with popular alternatives across fees, shipping, QC, and product range to choose the right platform.",
    updated: "2026-08-07",
    slug: "allchinabuy-alternatives",
  },
];